import { ChangeEvent, useState } from "react";

import { Card } from "@mui/material";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDEditor from "components/MDEditor";
import MDButton from "components/MDButton";

import { getFileNameFromUrl } from "helpers/utils";

import formCadastroEvento from "../schemas/forms";

// Material ui Icon
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {
  DeleteOutlineTwoTone,
  PictureAsPdfOutlined,
} from "@mui/icons-material";

import { deleteDocumentoEvento } from "services/evento";

import { setMessage, useMaterialUIController } from "context";

const { formField } = formCadastroEvento;
const { regulamento } = formField;

interface FieldDetailsProps {
  fileRegulamento: File | null;
  eventoId?: number;
  values: {
    [x: string]: string;
  };
  handlerFileReg: (event: ChangeEvent<HTMLInputElement>) => void;
  handlerDeleteFileReg: () => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export default function FieldRegulamento({
  values,
  eventoId,
  handlerDeleteFileReg,
  handlerFileReg,
  fileRegulamento,
  setFieldValue,
}: FieldDetailsProps) {
  const [, dispatch] = useMaterialUIController();
  const handlerExcluirArquivo = async () => {
    try {
      eventoId &&
        (await deleteDocumentoEvento(
          Number(eventoId),
          "urlRegulamento",
          getFileNameFromUrl(values.urlRegulamento)
        ).then((resp) => {
          if (resp.status === 200) {
            handlerDeleteFileReg();
            setFieldValue("urlRegulamento", "");
          }
        }));
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        text: error.message,
        severity: "error",
      });
    }
  };

  const DeleteRegulamento = () => {
    const [confirmed, setConfirmed] = useState<boolean>(false);

    return !confirmed ? (
      <IconButton component="label" onClick={() => setConfirmed(true)}>
        <DeleteOutlineTwoTone color="error" />
      </IconButton>
    ) : (
      <MDBox>
        <Typography variant="caption">Tem certeza?</Typography>
        <MDBox display="flex" gap={1}>
          <MDButton
            variant="outlined"
            color="success"
            size="small"
            onClick={handlerExcluirArquivo}
          >
            Sim
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            size="small"
            onClick={() => setConfirmed(false)}
          >
            Não
          </MDButton>
        </MDBox>
      </MDBox>
    );
  };

  return (
    <Card id="regulamento" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Regulamento</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Insira um arquivo PDF ou digite o regulamento no campo abaixo.
        </MDTypography>
      </MDBox>

      <MDBox pb={3} px={3}>
        <MDBox
          borderRadius="lg"
          display="flex"
          justifyContent={fileRegulamento ? "space-between" : "flex-start"}
          alignItems="center"
          p={1}
          sx={{
            backgroundColor: ({ palette: { light } }) => light.main,
            position: "relative",
            height: "auto",
            minHeight: "40px",
            border: ({ borders: { borderWidth, borderColor } }) =>
              `${borderWidth[1]} dashed ${borderColor}`,
          }}
        >
          {fileRegulamento ? (
            <>
              <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfOutlined fontSize="small" />
                <Typography variant="caption">
                  {fileRegulamento.name}
                </Typography>
              </MDBox>
              <Typography variant="caption">
                {fileRegulamento.size} byte
              </Typography>
              <IconButton component="label" onClick={handlerDeleteFileReg}>
                <DeleteOutlineTwoTone color="error" />
              </IconButton>
            </>
          ) : values.urlRegulamento !== "" ? (
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <MDTypography
                component="a"
                href={values.urlRegulamento}
                target="_blank"
                rel="noreferrer"
                variant="h6"
                textTransform="capitalize"
                sx={{
                  display: "flex",
                  justifyItems: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PictureAsPdfOutlined fontSize="small" />
                {getFileNameFromUrl(values.urlRegulamento)}
              </MDTypography>

              <DeleteRegulamento />
            </MDBox>
          ) : (
            <IconButton component="label" sx={{ padding: "10px", gap: 1 }}>
              <input
                name="urlRegulamento"
                type="file"
                hidden
                accept="application/pdf"
                onChange={handlerFileReg}
              />
              <PictureAsPdfOutlined fontSize="large" />
              <Typography variant="caption">Selecionar arquivo</Typography>
            </IconButton>
          )}
        </MDBox>
      </MDBox>

      {!fileRegulamento && (
        <MDBox pb={3} px={3}>
          <MDEditor
            name={regulamento.name}
            value={values.regulamento}
            onChange={setFieldValue}
            placeholder="Digite o regulamento..."
          />
        </MDBox>
      )}
    </Card>
  );
}
